import { Pjt } from "../../services/projects";

export type ProjectSearchPageState = {
  pjtNameOrDesc: string;
  prdDplymntDateRange: DateRange;
  stgDplymntDateRange: DateRange;
  pjtRgstrDateRange: DateRange;
  pjtStsList: string[];
  pjtLnchTypeList: string[];
  dipList: string[];
  isPmyOnly: string;
  userId: string;
  userName: string;
  cpntIdList: string[];

  displayedSearchForm: boolean;

  searchResult: {
    projectList: Pjt[];
  };

  fieldPath: {
    pjtNameOrDesc: string;
    prdDplymntDateRangFrom: string;
    prdDplymntDateRangTo: string;
    stgDplymntDateRangFrom: string;
    stgDplymntDateRangTo: string;
    pjtRgstrDateRangFrom: string;
    pjtRgstrDateRangTo: string;
    pjtStsList: string;
    pjtLnchTypeList: string;
    dipList: string;
    isPmyOnly: string;
    userId: string;
    userName: string;
    cpntIdList: string;
  };
};

export type DateRange = {
  startDate: string;
  endDate: string;
};

export type PageNewState =
  | ProjectSearchPageState
  | ((prevState: ProjectSearchPageState) => ProjectSearchPageState);
